import React from 'react'
import { Button } from './ui/button.jsx'
import { ChevronLeft, ChevronRight } from 'lucide-react'

export function LessonCard({
  color = 'blue',
  subjectLabel,
  headline,
  subline,
  onView,
  viewLabel = 'View lesson',
  onPrev,
  onNext,
  fullWidth = false,
  className = '',
}) {
  return (
    <div className={`border rounded-lg p-4 ${className}`}>
      <div className="p-4 pt-2">
        {/* Eyebrow with colored dot and subject */}
        {(subjectLabel || color) && (
          <div className="flex items-center gap-2 mb-1">
            <span className={`inline-block w-2 h-2 rounded-full bg-${color}-500`} />
            {subjectLabel && <span className="text-xs text-gray-500">{subjectLabel}</span>}
          </div>
        )}
        <div>
          {headline && <p className="text-sm font-medium text-gray-900">{headline}</p>}
          {subline && <p className="text-xs text-gray-500 mt-1">{subline}</p>}
        </div>
      </div>

      <div className="flex items-center gap-3 p-4 pt-0">
        {onPrev && (
          <button
            aria-label="Previous"
            className={`rounded-md border px-2 flex items-center justify-center h-10 text-${color}-600 hover:bg-${color}-50`}
            onClick={onPrev}
          >
            <ChevronLeft className="w-4 h-4" />
          </button>
        )}
        <Button
          className={`${fullWidth ? 'flex-1' : ''} h-10 rounded-md bg-${color}-500 hover:bg-${color}-600 text-white px-3 text-sm`}
          onClick={onView}
        >
          {viewLabel}
        </Button>
        {onNext && (
          <button
            aria-label="Next"
            className={`rounded-md border px-2 flex items-center justify-center h-10 text-${color}-600 hover:bg-${color}-50`}
            onClick={onNext}
          >
            <ChevronRight className="w-4 h-4" />
          </button>
        )}
      </div>
    </div>
  )
}
